export const GRAVAR_PARAMETROS = 'Gravar parâmetros';
export const GRAVAR_PARAMETROS_AGENDAMENTO = 'Gravar sessão do agendamento online';
export const LOGIN_AGENDAMENTO = 'Login no app de agendamento online';
export const LOGOUT_AGENDAMENTO = 'Logout do app de agendamento online';
export const ALTERAR_DATA_ATUAL = 'Alterar a data atual da agenda';
export const FILTRAR_CLIENTES = 'Alterar o filtro de clientes';
export const FILTRAR_PROFISSIONAIS = 'Alterar o filtro de profissionais';
export const FILTRAR_SERVICOS = 'Alterar o filtro de serviços';
export const FILTRAR_FUNCOES= 'Alterar o filtro de funções';
export const ALTERAR_TIPO_AGENDA = 'Alterar o tipo da agenda';
export const ATUALIZAR_LISTA_PROFISSIONAIS = 'Atualizar lista de profissionais para filtro';
export const ATUALIZAR_LISTA_SERVICOS = 'Atualizar lista de serviços para filtro';
export const ATUALIZAR_LISTA_FUNCOES = 'Atualizar lista de funções para filtro';
export const ATUALIZAR_CONFIGURACAO = 'Atualizar configuracao';
export const INICIALIZAR_CONFIGURACAO_CORES = 'Inicializar a configuracao de cores';
export const ATUALIZAR_CONFIGURACAO_FUNCAO = 'Atualizar configuração função'
export const EXIBIR_ERRO = 'Exibir mensagem de erro';
/*daqui pra baixo são novos, os de cima podemos verificar mais pra frente*/
export const AUTENTICACAO_MICROVIX_AGENDAMENTO_ONLINE = 'Autenticação do microvix no agendamento online';
export const LIMPAR_AUTENTICACAO_MICROVIX_AGENDAMENTO_ONLINE = 'Limpa autenticação do microvix no agendamento online';
export const AUTENTICACAO_MICROVIX_AGENDA = 'Autenticação do microvix no agenda';
export const LIMPAR_AUTENTICACAO_MICROVIX_AGENDA = 'Limpa autenticação do microvix no agenda';
export const LOGIN_AGENDAMENTO_ONLINE = 'Login de usuário no agendamento online';
export const LOGOUT_AGENDAMENTO_ONLINE = 'Logout de usuário no agendamento online';
export const GRAVAR_CONFIG_VISUAL_AGENDAMENTO_ONLINE = 'Grava as configurações visuais do agendamento online';
